import { EXPERIMENT_NAME_CHAR_LIMIT } from 'modules/experiments/constants';
import { EditableInput } from 'modules/templateEditor/common/Controls/EditableInput';

type ExperimentEditableInputProps = {
  setEditableName: (name: string) => void;
  handleReset: () => void;
  editableName: string;
};
export const ExperimentEditableInput = ({
  setEditableName,
  handleReset,
  editableName,
}: ExperimentEditableInputProps) => {
  return (
    <EditableInput
      data-test="experiment-name-edit-input"
      isRequired
      maxLength={EXPERIMENT_NAME_CHAR_LIMIT}
      onChange={setEditableName}
      placeholder={'Experiment name required.'}
      reset={handleReset}
      value={editableName}
    />
  );
};
